import classNames from 'classnames';
import React from 'react';

import styles from './index.module.less';

export const Line: React.FC = () => (
    <div className={classNames(styles.border)} />
);
